<app-trips-table
  [columns]="columns"
  [columnLabels]="columnLabels"
  [trips]="trips"
  [loading]="loading"
  [totalTrips]="totalTrips"
  [pageSize]="pageSize"
  [pageIndex]="pageIndex"
  (pageChange)="onPageChange($event)"
>
</app-trips-table>
